import React, { ReactNode } from 'react'
import { EditModeActions } from './EditModeActions'
import { ActionsMenu } from './ActionsMenu'

/**
 * Main container for grid toolbar
 */
interface GridToolbarProps {
  children: ReactNode
  style?: React.CSSProperties
}

const GridToolbarRoot: React.FC<GridToolbarProps> = ({ children, style }) => {
  return <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', ...style }}>{children}</div>
}

/**
 * Actions bar for grid (save, export, etc.)
 */
interface ActionsProps {
  children: ReactNode
  align?: 'left' | 'right' | 'space-between'
}

const Actions: React.FC<ActionsProps> = ({ children, align = 'right' }) => {
  let justifyContent: 'flex-start' | 'flex-end' | 'space-between'

  if (align === 'left') {
    justifyContent = 'flex-start'
  } else if (align === 'space-between') {
    justifyContent = 'space-between'
  } else {
    justifyContent = 'flex-end'
  }

  return <div style={{ display: 'flex', justifyContent, gap: '8px', alignItems: 'center' }}>{children}</div>
}

export const GridToolbar = Object.assign(GridToolbarRoot, {
  Actions,
  EditModeActions,
  ActionsMenu
})

export default GridToolbar
